module.exports = __webpack_public_path__ + "static/icons/icon-chevron-up-9eb2a03299e25363f0625ebdaaed9275.svg";